import { Store } from "pullstate";

export type FormStateProps = {
  login: string;
  password: string;
};

export const FormState = new Store({} as FormStateProps);
